var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('fast2-component-render',_vm._g(_vm._b({attrs:{"list":_vm.item.data,"mode":_vm.mode}},'fast2-component-render',_vm.$attrs,false),_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }